import { ELEVATION_Z_INDEX } from '#pplx/frontend/aether/components/internal/elevation/elevation.js';
/** Maximum browser-supported z-index, reserved for activation-order toast viewports. */
export const ACTIVATION_ORDER_TOAST_Z_INDEX = 2_147_483_647;
/**
 * Computes the z-index for the toast container.
 *
 * Toasts are app-level notifications that must paint above popovers, menus,
 * and modals. They render at the `toast` tier regardless of where they're
 * mounted in the tree.
 */
export function getToastZIndex() {
    return ELEVATION_Z_INDEX.toast;
}
//# sourceMappingURL=index.js.map